import React from 'react';
//Styles
import './About.css'
//Data
import { LANGUAGES } from '../../shared/languages';
import { PARTNERS } from '../../shared/partners';
//Tools & Animation
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Fade, Stagger } from 'react-animation-components';
//Component
import Header from '../Header/Header';



const partners = PARTNERS;
const languages = LANGUAGES;

const cardElement = (element) => (
    <div className='about__card'>
        <img src={element.image} alt="feature"  />
    </div>
)

const showCards = elements => elements.map(element => cardElement(element));

const partnersItems = showCards(partners);
const languagesItems = showCards(languages);
const responsive = {
    0: { items: 1 },
    768: { items: 2 },
    1024: { items: 4 },
    2380: { items: 7 }
};


const About = () => {

    return(
        <>
            <Header color={'var(--DarkNavy)'} barColor={'var(--Blue)'} bg={'block'}/>
            <div className="about__wrapper">
                <div className="about__content"> 
                    <div className="about__title">
                        <h1 className="about__bigtitle">
                            10+ Years, Focused on Media Translations
                        </h1>
                        <h2 className="intro">We provide End-to-End Translation <br/> in Over 90 Languages <br/>to Suit Your Go-To-Market Strategy.  </h2>
                        <div >
                            <Stagger in className="aboutservices">
                                <Fade in className="aboutservice"><h3>Media Translation</h3></Fade>
                                <Fade in className="aboutservice"><h3>Website & Software Translation</h3></Fade>
                                <Fade in className="aboutservice"><h3>Constant Management <br/> of Your Online-services</h3></Fade>
                            </Stagger>
                        </div>
                    </div>
                    
                    <div className='about__title'>
                        <h1 className="about__bigtitle">
                            Our Partners
                        </h1>
                        <h2>Here are our partners over the world.</h2>
                    </div>
                    <div className='about__cards'>
                        <AliceCarousel 
                            mouseTracking 
                            items={partnersItems} 
                            responsive={responsive} 
                            autoPlay={true} 
                            animationDuration={700}
                            autoPlayInterval={700}
                            disableButtonsControls={true}
                            disableDotsControls={true}
                            utoPlayStrategy={'none'}
                            infinite={true}
                            autoWidth={true}
                        />
                    </div>

                    <div className='about__title'>
                        <h1 className="about__bigtitle">
                            Languages
                        </h1>
                        <h2>We offer services for +90 languages.</h2>
                    </div>
                    <div className='about__cards'>
                        <AliceCarousel 
                            mouseTracking 
                            items={languagesItems} 
                            responsive={responsive} 
                            fadeOutAnimation={true}
                            autoPlay={true} 
                            animationDuration={800}
                            autoPlayInterval={800}
                            disableButtonsControls={true}
                            disableDotsControls={true}
                            infinite={true}
                            autoWidth={true}
                            autoPlayDirection={'rtl'}
                        />
                    </div> 
                </div>
            </div>
        </>
    )
    
}

export default About ;